import { Api } from 'utils';

class FormalityService {
  static get = async (params?: any) => Api.createResponse('app/formalities/', params);
  static getFormalities = async (params?: any) =>
    Api.createResponse('app/formalities/formalities', params);
  static generate = async (params?: any) => Api.createResponse('app/formalities/generate', params);
  static view = async (params?: any) => Api.createResponse('app/formalities/view', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/formalities/', params),
    create: async (params?: any) => Api.createResponse('admin/formalities/create', params),
    update: async (params?: any) => Api.createResponse('admin/formalities/update', params),
    updateTag: async (params?: any) => Api.createResponse('admin/formalities/tags/update', params),
    delete: async (params?: any) => Api.createResponse('admin/formalities/delete', params),
    getAreas: async (params?: any) => Api.createResponse('admin/formalities/areas', params),
    view: async (params?: any) => Api.createResponse('admin/formalities/view', params),
  };
}

export default FormalityService;
